import React from 'react';
import Card from 'src/common/refactoredComponents/card/Card';
import { MainContainerItems } from 'src/pages/orders/components/orderDetails/backOrderDetails/BackOrderDetails.styled';
import CfnLabel from 'src/common/components/orderDetails/bundleCards/CfnLabel';
import ItemDescriptionLabel from 'src/common/components/orderDetails/bundleCards/ItemDescriptionLabel';

const BackOrderSetContainer = ({
    children,
    setDetailCfn,
    setDescription,
    setItemHandler,
    setDetailsData,
    cardMargin,
    cardPadding,
}) => {
    return (
        <>
            <Card margin={cardMargin} padding={cardPadding}>
                <MainContainerItems width="100%">
                    <CfnLabel
                        cfnFontColor={'#140F4B'}
                        setItemHandler={setItemHandler}
                        setDetailsData={setDetailsData}
                        cfn={setDetailCfn}
                        isShowSetItemDetails={true}
                        cursor={'pointer'}
                    />

                    <ItemDescriptionLabel
                        lineHeight={'19px'}
                        letterSpacing={'-0.1px'}
                        description={setDescription}
                        fontSize={'13px'}
                        marginContainer={'10px 0 10px 0'}
                    />
                </MainContainerItems>
                {children}
            </Card>
        </>
    );
};

export default BackOrderSetContainer;
